<div class="outerCont">
  <span class="listItem" *ngFor="let customer of selectedCustomerEU">
    <i class="far fa-times-circle closeIcon" aria-hidden="true" (click)="removeCustomerEU(customer)"></i>
    {{customer}}    
  </span>
</div>